import { useRef, useEffect } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import Text from '../../../shared/Text';

const CHARACTERS_LIMIT = 75;

const HeadlineInput = ({ value, onChange, name, error, onBlur }) => {
  const { t } = useTranslation('tileForm');
  const displayValue = value.slice(0, CHARACTERS_LIMIT);

  const textareaRef = useRef(null);
  const charactersLeft = CHARACTERS_LIMIT - displayValue.length;

  const handleChange = e => {
    const textLength = e.target.value.length;
    if (textLength <= CHARACTERS_LIMIT) {
      onChange(e);
    }
  };

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = '0px';
      const { scrollHeight } = textareaRef.current;
      textareaRef.current.style.height = `${scrollHeight}px`;
    }
  }, [value]);

  return (
    <HeadlineWrapper>
      <Input
        rows={1}
        placeholder={t('headline.placeholder')}
        value={displayValue}
        onChange={handleChange}
        name={name}
        ref={textareaRef}
        onBlur={onBlur}
        maxLength={CHARACTERS_LIMIT}
      />
      <InputFooter>
        <Text variant="button" color="error.default">
          {error}
        </Text>
        <Text alignSelf="flex-end" variant="small4" color="black.60">
          {charactersLeft} {t('charactersLeft')}
        </Text>
      </InputFooter>
    </HeadlineWrapper>
  );
};

export default HeadlineInput;

const HeadlineWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Input = styled.textarea`
  overflow: hidden;
  height: 50px;
  color: ${themeGet('colors.black.100')};
  display: block;
  border: none;
  width: 100%;
  font-size: 22px;
  font-weight: 600;
  line-height: 23px;
  outline: none;
  padding: 24px 0 0;
  margin: 0;
`;

const InputFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 8px;
`;
